import FieldWrapper, { FieldWrapperProps } from './field-wrapper';
import { ReactNode } from 'react';
import { FieldValues, Path, useController, UseControllerProps } from 'react-hook-form';
import { TextInput, TextInputProps } from 'shared/ui/controls/text-input';

interface TsbNumbersFieldProps<T extends FieldValues>
  extends Omit<UseControllerProps<T>, 'name'>,
    Omit<FieldWrapperProps, 'children'>,
    Omit<TextInputProps, 'defaultValue' | 'name' | 'className'> {
  label?: ReactNode;
  required?: boolean;
  isSmallSize?: boolean;
  name?: Path<T>;
}

export const TsbNumbersFieldField = <T extends FieldValues>({
  label = 'TSB Numbers',
  required = false,
  name,
  isSmallSize = false,
  ...props
}: TsbNumbersFieldProps<T>) => {
  const {
    field,
    fieldState: { error }
  } = useController({
    ...props,
    name: name || ('tsbNumbers' as Path<T>)
  });

  const { value, ...rest } = field;

  return (
    <FieldWrapper label={label} error={error} required={required}>
      <TextInput isSmallSize={isSmallSize} error={error} value={value ?? ''} {...rest} {...props} autoComplete="off" />
    </FieldWrapper>
  );
};
